<template>
    <div style="position: relative">
        <vx-input
            ref="vxinput"
            :label="label"
            class="w-full"
            v-model="searchString"
            @focus="onFocus"
            @blur="onBlur"
            :autofocus="this.autofocus"
            :readonly="readonly"
        ></vx-input>
        <transition name="fade-bottom" appear>
            <vx-card
                v-show="showResults"
                class="w-full mt-2"
                style="z-index: 5000; position: absolute; transition-duration: all 0.2s"
            >
                <vx-client-side-table
                    v-model="selectedLine"
                    :data="searchResults ? searchResults : []"
                    :columns="searchResultColumns"
                >
                    <template v-slot:row="{ row }">
                        <slot name="row" :row="row"> </slot>
                    </template>
                </vx-client-side-table>
                <slot
                    name="noResults"
                    v-if="
                        searchString &&
                        searchResults &&
                        searchString.length >= 3 &&
                        searchResults.length == 0
                    "
                >
                </slot>
            </vx-card>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'vx-table-suggest',
    props: {
        value: {
            type: Object
        },
        searchUrl: {
            type: String,
            required: true
        },
        searchResultColumns: {
            type: Array,
            requred: true
        },
        autofocus: {
            type: Boolean
        },
        label: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timeoutCanceller: null,
            searchString: null,
            showResults: false,
            searchResults: null
        }
    },
    watch: {
        searchString: {
            handler: async function (val) {
                if (this.timeoutCanceller) {
                    clearTimeout(this.timeoutCanceller)
                }
                if (val && val.length >= 3) {
                    this.timeoutCanceller = setTimeout(async () => {
                        try {
                            var response = await this.$api.get(
                                `${this.searchUrl}?pageNo=0&pageSize=20&search=${val}`
                            )

                            if (response.data && response.data.data) {
                                this.searchResults = response.data.data
                            } else {
                                this.searchResults = response.data
                            }
                        } catch (err) {
                            this.notifyServerError(err)
                        }
                    }, 1000)
                } else {
                    this.selectedLine = null
                }
                // else dont search
            }
        },
        selectedLine: {
            handler: function (val) {
                if (val) {
                    this.showResults = false
                }
            }
        }
    },
    computed: {
        selectedLine: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        onFocus(e) {
            this.showResults = true
        },
        onBlur(e) {
            setTimeout(
                function () {
                    this.showResults = false
                }.bind(this),
                100
            )
            // this.$nextTick(() => (this.showResults = false))
        },
        clearSearchString() {
            this.searchString = ''
        },
        updateSearchString(v) {
            this.searchString = v
        },
        autofocusInput(e) {
            this.$refs.vxinput.focusInput()
            // this.showResults = false
        }
    }
}
</script>

<style></style>
